/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Room match group with room IDs only (not full details)
 * @export
 * @interface RoomMatchGroupWithItems
 */
export interface RoomMatchGroupWithItems {
    /**
     * Unique room match group ID
     * @type {number}
     * @memberof RoomMatchGroupWithItems
     */
    id: number;
    /**
     * ID of the parent comparison
     * @type {number}
     * @memberof RoomMatchGroupWithItems
     */
    comparisonId: number;
    /**
     * How this room match group was created
     * @type {string}
     * @memberof RoomMatchGroupWithItems
     */
    creationStatus: RoomMatchGroupWithItemsCreationStatusEnum;
    /**
     * User confirmation status of this room match
     * @type {string}
     * @memberof RoomMatchGroupWithItems
     */
    confirmationStatus?: RoomMatchGroupWithItemsConfirmationStatusEnum | null;
    /**
     * AI confidence score for this room match
     * @type {number}
     * @memberof RoomMatchGroupWithItems
     */
    confidence?: number | null;
    /**
     * Notes about this match
     * @type {string}
     * @memberof RoomMatchGroupWithItems
     */
    note?: string | null;
    /**
     * IDs of matched rooms from the insurer estimate
     * @type {Array<number>}
     * @memberof RoomMatchGroupWithItems
     */
    insurerRooms: Array<number>;
    /**
     * IDs of matched rooms from the contractor estimate
     * @type {Array<number>}
     * @memberof RoomMatchGroupWithItems
     */
    contractorRooms: Array<number>;
    /**
     * When the room match group was created
     * @type {Date}
     * @memberof RoomMatchGroupWithItems
     */
    createdAt?: Date;
    /**
     * When the room match group was last updated
     * @type {Date}
     * @memberof RoomMatchGroupWithItems
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const RoomMatchGroupWithItemsCreationStatusEnum = {
    AiCreated: 'ai_created',
    UserCreated: 'user_created',
    UserUpdated: 'user_updated'
} as const;
export type RoomMatchGroupWithItemsCreationStatusEnum = typeof RoomMatchGroupWithItemsCreationStatusEnum[keyof typeof RoomMatchGroupWithItemsCreationStatusEnum];

/**
 * @export
 */
export const RoomMatchGroupWithItemsConfirmationStatusEnum = {
    Confirmed: 'confirmed',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;
export type RoomMatchGroupWithItemsConfirmationStatusEnum = typeof RoomMatchGroupWithItemsConfirmationStatusEnum[keyof typeof RoomMatchGroupWithItemsConfirmationStatusEnum];


/**
 * Check if a given object implements the RoomMatchGroupWithItems interface.
 */
export function instanceOfRoomMatchGroupWithItems(value: object): value is RoomMatchGroupWithItems {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('creationStatus' in value) || value['creationStatus'] === undefined) return false;
    if (!('insurerRooms' in value) || value['insurerRooms'] === undefined) return false;
    if (!('contractorRooms' in value) || value['contractorRooms'] === undefined) return false;
    return true;
}

export function RoomMatchGroupWithItemsFromJSON(json: any): RoomMatchGroupWithItems {
    return RoomMatchGroupWithItemsFromJSONTyped(json, false);
}

export function RoomMatchGroupWithItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomMatchGroupWithItems {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comparisonId': json['comparisonId'],
        'creationStatus': json['creationStatus'],
        'confirmationStatus': json['confirmationStatus'] == null ? undefined : json['confirmationStatus'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'note': json['note'] == null ? undefined : json['note'],
        'insurerRooms': json['insurerRooms'],
        'contractorRooms': json['contractorRooms'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RoomMatchGroupWithItemsToJSON(json: any): RoomMatchGroupWithItems {
    return RoomMatchGroupWithItemsToJSONTyped(json, false);
}

export function RoomMatchGroupWithItemsToJSONTyped(value?: RoomMatchGroupWithItems | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'comparisonId': value['comparisonId'],
        'creationStatus': value['creationStatus'],
        'confirmationStatus': value['confirmationStatus'],
        'confidence': value['confidence'],
        'note': value['note'],
        'insurerRooms': value['insurerRooms'],
        'contractorRooms': value['contractorRooms'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

